<template>
  <div ref="dropbox" class="file-input">
    <div class="dropbox" v-if="!file">
      <label class="drop-label">
        <div v-if="uploadStatus!=='Uploading, please wait...'">{{ label }}</div>
        <input type="file" @change="onFileChange" @click="clearInput" />
      </label>
    </div>
    <div class="upload" v-else>
      <div class="file">
        <img :src="fileSrc" />
        <div>{{ name }}</div>
        <h4 v-if="!errorMsg">Upload this image?</h4>
        <button @click="removeFile">Cancel</button>
        <button v-if="!errorMsg" @click="confirmUpload">Confirm</button>
      </div>
    </div>
    <div>
      <i v-if="uploadStatus==='Upload Complete!'" class="fas fa-check"></i>
      <span>&nbsp; {{uploadStatus}}</span>
    </div>
    <div v-if="errorMsg">{{errorMsg}}</div>
  </div>
</template>

<script>
import Firebase from "firebase";
import dragAndDrop from "@/mixins/dragAndDrop";

export default {
  mixins: [dragAndDrop],
  data() {
    return {
      file: null,
      fileSrc: null,
      name: null,
      label:
        "Drag and drop your file here, or click to select a file to upload",
      userId: "",
      errorMsg: null,
      uploadTask: null,
      uploadStatus: ""
    };
  },
  methods: {
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.uploadStatus = "";
      this.file = files[0];
      this.name = files[0].name;
      this.fileSrc = URL.createObjectURL(files[0]);

      // size check
      const megaByte = 1024 * 1024;
      const maxFileSize = 50 * megaByte;
      if (!this.file.type.startsWith("image")) {
        this.errorMsg =
          "Oops! Make sure the file you're trying to upload is an image.";
        return;
      } else if (files[0].size > maxFileSize) {
        this.errorMsg = "File size too large! Must be under 50mb.";
        return;
      } else {
        this.errorMsg = null;
      }
    },
    confirmUpload() {
      if (!this.errorMsg) {
        this.firebaseStorageUpload(this.file);
        this.removeFile();
      }
    },
    clearInput(e) {
      e.target.value = null;
    },
    removeFile() {
      this.file = "";
      this.name = null;
    },
    async firebaseStorageUpload(file) {
      const storageRef = Firebase.storage().ref();
      const uploadRef = storageRef.child(`public-images/papers/${file.name}`);

      const metadata = {
        customMetadata: { userId: this.userId }
      };
      // https://firebase.google.com/docs/reference/js/firebase.storage.Reference#put
      const uploadTask = uploadRef.put(file, metadata);
      this.uploadTask = uploadTask;

      // Listen for state changes, errors, and completion of the upload.
      // https://firebase.google.com/docs/reference/js/firebase.storage.UploadTask
      uploadTask.on(
        Firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        snapshot => {
          switch (snapshot.state) {
            case Firebase.storage.TaskState.PAUSED: // or 'paused'
              this.uploadStatus = "Upload has been paused...";
              break;
            case Firebase.storage.TaskState.RUNNING: // or 'running'
              this.uploadStatus = "Uploading, please wait...";
              break;
          }
        },
        error => {
          // A full list of error codes is available at
          // https://firebase.google.com/docs/storage/web/handle-errors
          switch (error.code) {
            case "storage/unauthorized":
              this.uploadStatus =
                "User doesn't have permission to access the object";
              break;

            case "storage/unknown":
              this.uploadStatus =
                "Unknown error occurred, inspect error.serverResponse";
              break;
          }
        },
        async () => {
          // Upload completed successfully
          // change page in ImportDataModal and start fetching upload status
          this.uploadStatus = "Upload Complete!";
        }
      );
    }
  }
};
</script>

<style scoped>
.file-input {
  max-width: 100%;
  margin-top: 1rem;
  display: block;
}

.dropbox {
  border: 2px dashed #cccccc;
  color: #cccccc;
  max-width: 30rem;
  margin: 1vh auto;
  text-align: center;
  border-radius: 8px;
}

.drop-link {
  background-color: white;
}

.dropbox:hover {
  background-color: #f4f4f8;
  cursor: pointer;
}

.dropbox > label {
  padding: 10%;
  margin: auto;
  display: block;
  color: #3f4cec;
  text-align: center;
  line-height: 21px;
}

.dropbox > label:hover {
  cursor: pointer;
}

.uploading {
  width: 100%;
  height: 150px;
  text-align: center;
  padding-top: 50px;
}

.uploading .percentage {
  margin-top: 10px;
}

.upload {
  width: 100%;
  min-height: 150px;
}

button {
  margin: 0 1rem;
  padding: 0.3rem 1rem;
}

button:hover {
  cursor: pointer;
}

@media (max-width: 768px) {
  .file-input {
    margin-top: 25px;
  }
}

.fas.fa-check {
  color: green;
}
</style>
